export const reactUiModalHeaderTopPadding = 24;
export const reactUiModalHeaderRightPadding = 112;
export const reactUiModalHeaderBottomPadding = 24;
export const reactUiModalHeaderBottomPaddingMode2 = 8;

export const reactUiModalLeftPadding = 32;
export const reactUiModalRightPadding = 32;
export const reactUiModalBottomPadding = 32;

export const reactUiModalFooterTopPadding = 24;
export const reactUiModalFooterBottomPadding = 24;
